import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import LoginContainer from './LoginContainer';
import Locale from '../Translate/Locale';
import Heading1 from '../common/Heading1';
import container from '../../container';

import styles from './SSOCallbackPage.scss';
import ErrorContainer from './ErrorContainer';

function SSOCallbackPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [urlParams] = useSearchParams();
  const code = urlParams.get('code');

  const { isError, data, mutate } = useMutation({
    mutationKey: ['postSSOToken', code],
    mutationFn: async () => {
      return container.touchpointsApi.postSSOToken(code);
    },
    retry: false,
  });

  useEffect(() => {
    if (code) {
      mutate();
      return;
    }
    navigate('/login/sso');
  }, [code]);

  useEffect(() => {
    if (data) {
      dispatch({
        type: 'REFRESH_TOKEN',
        data: {
          refresh_token: data.refreshToken,
          token: data.accessToken,
        },
      });
      navigate('/home');
    }
  }, [data]);

  return (
    <LoginContainer>
      <div className={styles.loginBox}>
        <Heading1 styleName="title">Signing in...</Heading1>
        <div className={styles.subTitle}>
          <Locale>Please wait while we authenticate you</Locale>
        </div>
        {isError && (
          <ErrorContainer
            text={'Something went wrong, please try again later'}
            buttonLink="/login/sso"
          ></ErrorContainer>
        )}
      </div>
    </LoginContainer>
  );
}

export default SSOCallbackPage;
